import { render } from "./BasicLayout.vue?vue&type=template&id=38b95955&class=bg"
const script = {}

import "./BasicLayout.vue?vue&type=style&index=0&id=38b95955&lang=css"

import exportComponent from "/var/www/ambientaly/prod/front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__